import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_PINK
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-dashboard-stats',
	templateUrl: './dashboard-stats.component.html',
	styleUrls: ['./dashboard-stats.component.scss']
})
export class DashboardStatsComponent implements OnInit {
	@Input() weekNumber: number;

	loading = true;
	statsDataAvailable = false;
	statsEmployee: any;

	globalStats: any;
	lpcStats: any;
	lsfStats: any;
	pdnStats: any;
	stats: any;
	satisfactionRate = 88.88;
	satisfactionRateLpc = 88.88;
	satisfactionRateLds = 88.88;
	satisfactionRatepdn = 88.88;
	satisfactionRateSAAD = 88.88;

	chartOptionSatisfactionLSF: EChartsOption;
	chartOptionSatisfactionLPC: EChartsOption;
	chartOptionSatisfactionPDN: EChartsOption;
	chartOptionSatisfactionSAAD: EChartsOption;

	chartOptionTempsTravail: EChartsOption;
	chartOptionDistance: EChartsOption;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(
		private facade: FacadeService,
		private logger: LogService,
		private dateUtils: DateUtils
	) {}

	ngOnInit(): void {
		// this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		// this.isSAAD = this.facade.dataStorageService.isSAAD();
		// this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.initGlobalReport();
	}

	initGlobalReport() {
		this.facade.statistiqueService
			.getStatisticsByYearAndWeekNumber(
				new Date().getFullYear(),
				this.weekNumber
			)
			.subscribe((stats: any) => {
				this.logger.log(stats);
				this.loading = false;
				this.statsDataAvailable =
					stats.beanCategories[0].numberFormation > 0 ? true : false;

				const statsByCategory = stats.beanCategories;
				this.stats = statsByCategory;
				this.globalStats = statsByCategory[0];
				this.lpcStats = statsByCategory[1];
				this.lsfStats = statsByCategory[2];
				this.pdnStats = statsByCategory[3];

				this.generateSatisfactionCharts();
				this.statsDataAvailable = true;
			});
	}

	generateSatisfactionCharts() {
		if (isNaN(this.globalStats) && this.globalStats) {
			this.satisfactionRate = 88.888;
			const rateGlobal = this.globalStats.numberFormation
				? 1 -
				  this.globalStats.numberSpeNoRespecte /
						this.globalStats.numberFormation
				: 1;
			// Round to three decimal and multiply to get a percentage
			// this.satisfactionRate = this.roundToTwo(rateGlobal);
			this.satisfactionRate = 100.0 * rateGlobal;

			if (
				//this.isSESSAD &&
				isNaN(this.pdnStats) &&
				isNaN(this.lsfStats) &&
				isNaN(this.lpcStats)
			) {
				const rateLpc = this.lpcStats?.numberFormation
					? 1 -
					  this.lpcStats?.numberSpeNoRespecte / this.lpcStats?.numberFormation
					: 1;
				// this.satisfactionRateLpc = this.roundToTwo(rateLpc);
				this.satisfactionRateLpc = 100.0 * rateLpc;

				const rateLds =
					this.lsfStats.numberFormation > 0
						? 1 -
						  this.lsfStats.numberSpeNoRespecte / this.lsfStats.numberFormation
						: 1;
				// this.satisfactionRateLds = this.roundToTwo(rateLds);
				this.satisfactionRateLds = 100.0 * rateLds;

				const ratepdn =
					this.pdnStats.numberFormation > 0
						? 1 -
						  this.pdnStats.numberSpeNoRespecte / this.pdnStats.numberFormation
						: 1;
				// this.satisfactionRateLds = this.roundToTwo(rateLds);
				this.satisfactionRatepdn = 100.0 * ratepdn;

				this.chartOptionSatisfactionLPC = {
					title: [
						{
							text: '' + this.satisfactionRateLpc.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'LPC',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'LPC',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateLpc,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Formations LPC satisfaites'
								},
								{
									value: 100 - this.satisfactionRateLpc,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations LPC insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};
				this.chartOptionSatisfactionLSF = {
					title: [
						{
							text: '' + this.satisfactionRateLds.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'LSF',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'LSF',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateLds,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Formations LSF satisfaites'
								},
								{
									value: 100 - this.satisfactionRateLds,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations LSF insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};

				this.chartOptionSatisfactionPDN = {
					title: [
						{
							text: '' + this.satisfactionRatepdn.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'Prise de notes',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'LPC',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRatepdn,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Formations Prise de notes satisfaites'
								},
								{
									value: 100 - this.satisfactionRatepdn,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations Prise de notes insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};

				this.chartOptionDistance = {
					// title: {
					//   text: 'Distance parcourue en moyenne (km)',
					//   left: 'center'
					// },
					tooltip: {
						trigger: 'axis',
						formatter: '<strong> {b} </strong> : {c} km',
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					//   top: 80,
					//   bottom: 30
					// },
					xAxis: {
						type: 'value',
						position: 'top',
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					yAxis: {
						type: 'category',
						axisLine: { show: false },
						axisLabel: { show: false },
						axisTick: { show: false },
						splitLine: { show: false }
					},
					series: [
						{
							name: 'Distance parcourue en moyenne (km)',
							type: 'bar',
							stack: 'Total',
							label: {
								show: true,
								formatter: '{b}'
							},
							data: [
								{
									value: !isNaN(
										this.pdnStats.beanParametreStatistiqueDistance
											.distanceMoyenne
									)
										? this.pdnStats.beanParametreStatistiqueDistance
												.distanceMoyenne / 1000
										: 0,
									itemStyle: { color: THEME_COLOR_PINK },
									name: 'Prise de notes'
								},
								{
									value: !isNaN(
										this.lsfStats.beanParametreStatistiqueDistance
											.distanceMoyenne
									)
										? this.lsfStats.beanParametreStatistiqueDistance
												.distanceMoyenne / 1000
										: 0,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'LSF'
								},
								{
									value: !isNaN(
										this.lpcStats.beanParametreStatistiqueDistance
											.distanceMoyenne
									)
										? this.lpcStats.beanParametreStatistiqueDistance
												.distanceMoyenne / 1000
										: 0,
									itemStyle: { color: THEME_COLOR_BLUE },
									name: 'LPC'
								}
							]
						}
					]
				};

				this.chartOptionTempsTravail = {
					// title: {
					//   text: 'Distance parcourue en moyenne (km)',
					//   left: 'center'
					// },
					tooltip: {
						trigger: 'axis',
						formatter(params) {
							params = params[0];
							const dateutil = new DateUtils();
							return (
								'<strong>' +
								params.name +
								'</strong>' +
								' :  ' +
								dateutil.timeConvert(params.value)
							);
						},
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					//   top: 80,
					//   bottom: 30
					// },
					xAxis: {
						type: 'value',
						axisLabel: {
							formatter(value) {
								const dateutil = new DateUtils();
								return dateutil.timeConvert(value);
							}
						},
						position: 'top',
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					yAxis: {
						type: 'category',
						axisLine: { show: false },
						axisLabel: { show: false },
						axisTick: { show: false },
						splitLine: { show: false }
					},
					series: [
						{
							name: 'Temps de travail moyen (heure)',
							type: 'bar',
							stack: 'Total',
							label: {
								show: true,
								formatter: '{b}'
							},
							data: [
								{
									value: !isNaN(
										this.dateUtils.convertStringHoursToNumber(
											this.pdnStats.beanParametreStatistiqueTempsTravail
												.tempsMoyenne
										)
									)
										? this.dateUtils.convertStringHoursToNumber(
												this.pdnStats.beanParametreStatistiqueTempsTravail
													.tempsMoyenne
										  )
										: 0,
									itemStyle: { color: THEME_COLOR_PINK },
									name: 'Prise de notes'
								},
								{
									value: !isNaN(
										this.dateUtils.convertStringHoursToNumber(
											this.lsfStats.beanParametreStatistiqueTempsTravail
												.tempsMoyenne
										)
									)
										? this.dateUtils.convertStringHoursToNumber(
												this.lsfStats.beanParametreStatistiqueTempsTravail
													.tempsMoyenne
										  )
										: 0,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'LSF'
								},
								{
									value: !isNaN(
										this.dateUtils.convertStringHoursToNumber(
											this.lpcStats.beanParametreStatistiqueTempsTravail
												.tempsMoyenne
										)
									)
										? this.dateUtils.convertStringHoursToNumber(
												this.lpcStats.beanParametreStatistiqueTempsTravail
													.tempsMoyenne
										  )
										: 0,
									itemStyle: { color: THEME_COLOR_BLUE },
									name: 'LPC'
								}
							]
						}
					]
				};
			} else if (this.isSAAD) {
				const rateSAAD = this.globalStats?.numberFormation
					? 1 -
					  this.globalStats?.numberSpeNoRespecte /
							this.globalStats?.numberFormation
					: 1;
				this.satisfactionRateSAAD = 100.0 * rateSAAD;

				this.chartOptionSatisfactionSAAD = {
					title: [
						{
							text: '' + this.satisfactionRateSAAD.toFixed(1) + '%',
							left: 'center',
							top: '32%',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						},
						{
							text: 'Aide à domicile',
							left: 'center',
							textStyle: {
								color: THEME_COLOR_MAIN
							}
						}
					],
					tooltip: {
						show: false
						// trigger: 'item',
						// formatter: '{b} : {d}%',
					},
					calculable: true,
					series: [
						{
							name: 'Aide à domicile',
							center: ['50%', '35%'],
							data: [
								{
									value: this.satisfactionRateSAAD,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Formations satisfaites'
								},
								{
									value: 100 - this.satisfactionRateSAAD,
									itemStyle: { color: '#FFFFFF' },
									name: 'Formations insatisfaites'
								}
							],
							label: {
								show: false
							},
							stillShowZeroSum: false,
							type: 'pie',
							radius: ['55%', '85%'],
							emphasis: {
								scale: false
							}
						}
					]
				};

				this.chartOptionDistance = {
					// title: {
					//   text: 'Distance parcourue en moyenne (km)',
					//   left: 'center'
					// },
					tooltip: {
						trigger: 'axis',
						formatter: '<strong> {b} </strong> : {c} km',
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					//   top: 80,
					//   bottom: 30
					// },
					xAxis: {
						type: 'value',
						position: 'top',
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					yAxis: {
						type: 'category',
						axisLine: { show: false },
						axisLabel: { show: false },
						axisTick: { show: false },
						splitLine: { show: false }
					},
					series: [
						{
							name: 'Distance parcourue en moyenne (km)',
							type: 'bar',
							stack: 'Total',
							label: {
								show: true,
								formatter: '{b}'
							},
							data: [
								{
									value: !isNaN(
										this.globalStats.beanParametreStatistiqueDistance
											.distanceMoyenne
									)
										? this.globalStats.beanParametreStatistiqueDistance
												.distanceMoyenne / 1000
										: 0,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Aide à domicile'
								}
							]
						}
					]
				};

				this.chartOptionTempsTravail = {
					// title: {
					//   text: 'Distance parcourue en moyenne (km)',
					//   left: 'center'
					// },
					tooltip: {
						trigger: 'axis',
						formatter(params) {
							params = params[0];
							const dateutil = new DateUtils();
							return (
								'<strong>' +
								params.name +
								'</strong>' +
								' :  ' +
								dateutil.timeConvert(params.value)
							);
						},
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					//   top: 80,
					//   bottom: 30
					// },
					xAxis: {
						type: 'value',
						axisLabel: {
							formatter(value) {
								const dateutil = new DateUtils();
								return dateutil.timeConvert(value);
							}
						},
						position: 'top',
						splitLine: {
							lineStyle: {
								type: 'dashed'
							}
						}
					},
					yAxis: {
						type: 'category',
						axisLine: { show: false },
						axisLabel: { show: false },
						axisTick: { show: false },
						splitLine: { show: false }
					},
					series: [
						{
							name: 'Temps de travail moyen (heure)',
							type: 'bar',
							stack: 'Total',
							label: {
								show: true,
								formatter: '{b}'
							},
							data: [
								{
									value: !isNaN(
										this.dateUtils.convertStringHoursToNumber(
											this.globalStats.beanParametreStatistiqueTempsTravail
												.tempsMoyenne
										)
									)
										? this.dateUtils.convertStringHoursToNumber(
												this.globalStats.beanParametreStatistiqueTempsTravail
													.tempsMoyenne
										  )
										: 0,
									itemStyle: { color: THEME_COLOR_GREEN },
									name: 'Aide à domicile'
								}
							]
						}
					]
				};
			}
		}
	}

	voirPlus() {
		this.facade.dataStorageService.setParam('statWeekNumber', this.weekNumber);
	}
}
